import AutoSelectRunNowConfirmation from './AutoSelectRunNowConfirmation';

export default AutoSelectRunNowConfirmation;
